/**
 * NUDIENT: Filterlådan och modellen i filtret, paket E3, M-100. Plan:
 * nudient/PLAN-E3-filter.md. Laddas av sections/nudient-collection-grid.liquid.
 *
 * Horizons filter byggs inte om, CLAUDE.md. Skriptet ändrar bara i det
 * Horizon redan har ritat, och gör om det efter varje omritning, eftersom
 * Horizon ritar om rutnätets sektion vid varje filterbyte:
 *
 * - Väljaren för lådan, Panel/Model 508:1383, flyttas från filterraden
 *   överst i lådan, M-100 punkt 1.
 * - Lådans rubrik blir "FILTER & SORT", 508:1377, och knappen "Show N
 *   products", 508:9029, Nudients texter, M-100 tillägget. N är Horizons
 *   antal, data-results-count.
 * - "Rensa alla" behåller modellen: modellens värde i adressen läggs i
 *   Horizons data-url, som Horizon läser vid klicket, assets/facets.js rad
 *   597 till 613. Planen punkt 2.
 * - Horizons knapp för det valda modellvärdet döljs. Den känns igen på att
 *   dess adress saknar modellen fast sidan har den, och att den är en
 *   bricka, facets-remove__pill.
 * - Färggruppen är utfälld och de andra infällda från början, och kundens
 *   egna val står kvar efter omritningen, 508:1375.
 * - Sorteringen A–Z och Z–A döljs, som SortMenu 505:8958 och det gamla
 *   temat. I rullgardinen i mobil tas alternativen bort, eftersom Safari inte
 *   döljer alternativ med CSS.
 * - Ett tryck utanför lådan från 990 stänger den, som varukorgslådan i C1.
 * - Bakåtknappen: Horizon ritar inte om rutnätet när adressen byts med
 *   bakåt, och då skulle sidan visa fel modell. Byts modellen i adressen
 *   med bakåt eller framåt laddas sidan om.
 *
 * Värden som inte kommer från butiken eller en token:
 * - filters-drawer, filters-drawer-heading, facets-drawer__filters,
 *   facets__see-results, facets-remove__pill, facets__clear-all och
 *   facets__clear-all-link: Horizons id och klasser i blocks/filters.liquid
 *   och snippets/filter-remove-buttons.liquid.
 * - data-skip-subtree-update: Horizons attribut i assets/morph.js, så att
 *   rubriken inte skrivs tillbaka vid omritningen, M-085.
 * - title-ascending och title-descending: Shopifys sortering A–Z och Z–A.
 * - view: Shopifys parameter för en annan mall, som provsidorna använder.
 * - [number]: platshållaren i knappens text.
 * - filter-p-m-attribute-colour_for_filtering: färggruppens namn hos Horizon.
 */

const bar = () => document.querySelector('[data-nudient-filter-bar]');

const param = () => bar()?.getAttribute('data-param') || 'filter.p.m.attribute.compatible_models';

/** Modellens värde i adressen, eller null. */
const currentModel = () => new URL(window.location.href).searchParams.get(param());

/**
 * Lägger modellen i en adress som saknar den, och view, mallens namn i
 * adressen, så att "Rensa alla" stannar i samma mall. Horizons
 * results.url har ingen av dem.
 */
const withModel = (href) => {
  const value = currentModel();
  if (!value || !href) return href;
  const url = new URL(href, window.location.origin);
  if (url.searchParams.has(param())) return href;
  url.searchParams.set(param(), value);
  const view = new URL(window.location.href).searchParams.get('view');
  if (view && !url.searchParams.has('view')) url.searchParams.set('view', view);
  return url.pathname + url.search;
};

const placePanelModel = (drawer) => {
  const filters = drawer.querySelector('.facets-drawer__filters');
  if (!filters || filters.querySelector('[data-nudient-panel-model]')) return;
  const block = document.querySelector('[data-nudient-panel-model]');
  if (!block || drawer.contains(block)) return;
  block.hidden = false;
  filters.prepend(block);
};

const setTexts = (drawer) => {
  const source = bar();
  if (!source) return;
  const heading = drawer.querySelector('#filters-drawer-heading');
  const title = source.getAttribute('data-title-text') || '';
  if (heading && title && heading.textContent !== title) {
    heading.textContent = title;
    heading.setAttribute('data-skip-subtree-update', '');
  }
  const button = drawer.querySelector('.facets__see-results');
  const form = drawer.querySelector('facets-form-component[data-results-count]');
  const count = form?.getAttribute('data-results-count');
  const template = source.getAttribute('data-show-text') || '';
  if (button && count && template) {
    const text = template.replace('[number]', count);
    if (button.textContent.trim() !== text) button.textContent = text;
  }
};

const keepModel = () => {
  const value = currentModel();
  document.querySelectorAll('facet-remove-component[data-url]').forEach((element) => {
    if (!(element instanceof HTMLElement)) return;
    const href = element.dataset.url || '';
    const hasModel = new URL(href, window.location.origin).searchParams.has(param());
    const isPill = element.classList.contains('facets-remove__pill');
    if (isPill) {
      element.hidden = Boolean(value) && !hasModel;
      return;
    }
    if (element.classList.contains('nudient-filter-chip')) return;
    const clear = element.querySelector('.facets__clear-all, .facets__clear-all-link') || element.matches('[ref="clearButton"]');
    if (clear && value && !hasModel) element.dataset.url = withModel(href);
  });
};

const hideTitleSort = () => {
  document.querySelectorAll('input[name="sort_by"]').forEach((input) => {
    if (!(input instanceof HTMLInputElement) || !input.value.startsWith('title-')) return;
    const row = input.closest('li, .sorting-filter__option, label') || input;
    if (row instanceof HTMLElement) row.hidden = true;
  });
  document.querySelectorAll('select[name="sort_by"] option').forEach((option) => {
    if (option instanceof HTMLOptionElement && option.value.startsWith('title-')) option.remove();
  });
};

/*
 * Grupperna: färgen utfälld och de andra infällda från början, som
 * FilterPanel 508:1375. Horizon fäller ut alla och skriver tillbaka det vid
 * varje omritning, så kundens egna val sparas för sidvisningen och läggs
 * tillbaka.
 */
const OPEN_FROM_START = 'filter-p-m-attribute-colour_for_filtering';
const groupState = new Map();

const placeGroups = (drawer) => {
  drawer.querySelectorAll('accordion-custom').forEach((group) => {
    const name =
      group.getAttribute('data-filter-param-name') ||
      (group.querySelector('price-facet-component') ? 'price' : '') ||
      (group.closest('.sorting-filter') ? 'sort' : '');
    if (!name) return;
    const details = group.querySelector('details');
    if (!(details instanceof HTMLDetailsElement)) return;
    if (!details.dataset.nudientWatched) {
      details.dataset.nudientWatched = '1';
      details.addEventListener('toggle', () => {
        if (details.dataset.nudientSetting) return;
        groupState.set(name, details.open);
      });
    }
    const wanted = groupState.has(name) ? groupState.get(name) : name === OPEN_FROM_START;
    if (details.open !== wanted) {
      details.dataset.nudientSetting = '1';
      details.open = wanted;
      requestAnimationFrame(() => delete details.dataset.nudientSetting);
    }
  });
};

let scheduled = false;
const apply = () => {
  scheduled = false;
  const drawer = document.getElementById('filters-drawer');
  if (drawer) {
    placePanelModel(drawer);
    setTexts(drawer);
    placeGroups(drawer);
  }
  keepModel();
  hideTitleSort();
};

const schedule = () => {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(apply);
};

apply();
const section = bar()?.closest('.shopify-section');
if (section) new MutationObserver(schedule).observe(section, { childList: true, subtree: true });

let rendered = currentModel();
document.addEventListener('nudient-model-picker:filter', () => {
  rendered = currentModel();
});
window.addEventListener('popstate', () => {
  if (!bar() || currentModel() === rendered) return;
  window.location.reload();
});

/*
 * Tryck utanför lådan från 990, som varukorgslådan i assets/nudient-cart.js:
 * Horizon stänger bara vid tryck på bakgrunden i modalt läge. Trycket når
 * inte sidan under.
 */
document.addEventListener(
  'click',
  (event) => {
    const element = document.getElementById('filters-drawer');
    const dialog = element?.querySelector('dialog');
    if (!element || !dialog?.open || dialog.matches(':modal')) return;
    if (!(event.target instanceof Node) || dialog.contains(event.target)) return;
    if (event.target instanceof Element && event.target.closest('[aria-controls="filters-drawer"]')) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof (/** @type {any} */ (element).close) === 'function') /** @type {any} */ (element).close();
  },
  true
);
